import { useState, useEffect, useContext } from 'react';
import * as wasm from 'sched';
import { WorkspaceContext } from '../context/WorkspaceContext';

export type FuzzyScheduleResult = wasm.DatabaseFuzzyScheduleResult;

// Hook to access the fuzzy schedule data (recomputed on every database change)
export function useSchedule() {
  const { safeData } = useContext(WorkspaceContext);
  const [schedule, setSchedule] = useState<FuzzyScheduleResult | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!safeData) return;

    setLoading(true);

    // Callback receives the DatabaseFuzzyScheduleResult DTO (plain JS object)
    const callback = (newSchedule: FuzzyScheduleResult | null) => {
      setSchedule(newSchedule);
      setLoading(false);
    };

    const jsCallback = callback as unknown as Function;

    const subscribeToSchedule = async () => {
      try {
        await wasm.DataManager.select_schedule(safeData, jsCallback);
      } catch (err) {
        console.error('Error subscribing to schedule changes:', err);
        setLoading(false);
      }
    };

    subscribeToSchedule();

    return () => {
      if (safeData) {
        wasm.DataManager.unsubscribe(safeData, jsCallback)
          .catch((err: any) => console.error('Error unsubscribing:', err));
      }
    };
  }, [safeData]);

  return {
    schedule,
    loading,
  };
}
